import { StyleSheet, Text, View, Image } from '@react-pdf/renderer';
import React, { useMemo } from 'react';
import useBackwardsCompatible from '../../../../hooks/useBackwardsCompatible';
import { Dashboard } from '../../../../types/files';
import theme from '../../../../theme';

const styles = StyleSheet.create({
    queryBlock: {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    answerBlock: {
        width: '100%',
        height: 'auto',
        paddingTop: 8,
        paddingBottom: 8,
        color: '#666666',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#666666',
    },
    row: {
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: 24,
    },
    col: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: 4,
    },
    icon: {
        width: 12,
        height: 12,
    },
    label: {
        fontFamily: 'Inter',
        fontSize: 10,
        fontWeight: 600,
        color: theme.palette.primary.main,
        paddingHorizontal: 1,
    },
    sublabel: {
        fontFamily: 'Inter',
        fontSize: 9,
        fontWeight: 500,
        color: '#666666',
    },
});

const PDFDealOwner: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const { dashboardOwner } = useBackwardsCompatible();

    const owner = useMemo(() => dashboardOwner(dashboard), [dashboard, dashboardOwner]);

    return (<>
        <View style={styles.queryBlock}>
            <Text style={styles.title}>
                {'Deal Owner'}
            </Text>
            <View style={styles.answerBlock}>
                <View style={styles.row}>
                    {(!!owner?.name || !!owner?.email) ? (<>
                        <Image style={styles.icon} src={'/images/user-gray.png'} />
                        <View style={styles.col}>
                            {!!owner?.name && (
                                <Text style={styles.label}>{owner.name}</Text>
                            )}
                            {!!owner?.email && (
                                <Text style={[styles.label, styles.sublabel]}>{owner.email}</Text>
                            )}
                        </View>
                    </>) : (
                        <Text style={[styles.label, styles.sublabel]}>{'No deal owner'}</Text>
                    )}
                </View>
            </View>
        </View>
    </>);
}

export default PDFDealOwner;
